import {useState} from 'react'
import Modal from '@mui/material/Modal'
import './HangingMenus.css'
import { madhuri_gattu_mail, lkm_oracle_team_mail } from '../../utils/mailIds'

const HangingMenus = () => {
    const [show, setShow] = useState(false);
    const [showBot, setShowBot] = useState(false);        
  
    const handleOpenModal = () => {
        setShow(true);
    };
  
    const handleCloseModal = () => {
        setShow(false);
    };    

    const handleBot = () => {        
        setShowBot(!showBot);                
    }                

    return (
        <div className="Oracle-socialMediaWrap">
            <button className="Oracle-iconBtn Oracle-icon6">
                <a href="/Oracle/calendar" target="_blank" rel="noreferrer">
                <img src={process.env.PUBLIC_URL + '/images/SAP/sap_calendar.png'} alt="oracle-icon" />
                <span>Oracle Calendar</span>
                </a>
            </button>
            <button className="Oracle-iconBtn Oracle-icon5">
                <a href="https://atci.lkm.accenture.com/LKM-eCatalog/Oracle-Flipbook" target="_blank" rel="noreferrer">
                <img src={process.env.PUBLIC_URL + '/images/SAP/catalogue_icon.png'} alt="ecatalogs-icon" />
                <span>Oracle eCatalog</span>
                </a>
            </button>
            <button className="Oracle-iconBtn Oracle-icon4" onClick={handleBot}>
                <img src={process.env.PUBLIC_URL + '/images/SocialLearning/noun-chatbot-4562760.svg'} alt="oracle-icon" />
                <span>Oracle Bot</span>
            </button>            
            {showBot && <iframe title="testing"src='https://webchat.botframework.com/embed/ipsacademyqna-bot123?s=8p2aCk7PUKo.-GWZwD7lUsjLriI1IYrOik770ZAAx5fRdjPhXHAZALo' className='oracle-bot'></iframe>}
            <button onClick={handleOpenModal} className="Oracle-iconBtn Oracle-icon1">
                <img src={process.env.PUBLIC_URL + '/images/SocialLearning/present.svg'} alt="oracle-icon" />
                <span>Request for Training</span>
            </button>
            <Modal
                open={show}
                onClose={handleCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div className="model-container">
                <span className="close_btn_model_reqtraining" onClick={handleCloseModal}>
                    X
                </span>
                <h4>Request For Training</h4>
                <div className="model_heading_reqtraining">
                    <p className="model_name_reqtraining">
                    <a
                        href="https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Link to raise training request
                    </a>
                    </p>
                    <div className="modal_content_reqtraining">
                    For further queries please get in touch with <br />
                    </div>
                    <p className="model_contact_reqtraining">
                    <a href={`mailto:${madhuri_gattu_mail}`} target="_blank" rel="noreferrer">
                        Madhuri Gattu.
                    </a>
                    </p>
                </div>
                </div>
            </Modal>            
            <button className="Oracle-iconBtn Oracle-icon2">
                <a
                href="https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI3OTUzMTgyNzIwMCJ9/all"
                target="_blank"
                rel="noreferrer"
                >
                <img src={process.env.PUBLIC_URL + '/images/SocialLearning/Yammer1.png'} alt="oracle-icon" />
                <span>Connect with Community</span>
                </a>
            </button>
            <button className="Oracle-iconBtn Oracle-icon3">
                <a href={`mailto:${lkm_oracle_team_mail}`} target="_blank" rel="noreferrer">
                <img src={process.env.PUBLIC_URL + '/images/SocialLearning/mail.svg'} alt="oracle-icon" />
                <span>Contact Us</span>
                </a>
            </button>
        </div>
    )
}

export default  HangingMenus